import axios from 'axios'
import CodeEmail from '../templates/default';
export default async function sendEmail({
    from = 'example@mailjet.com',
    to = 'example@example.com',
    userName = 'user',
    message = 'message',
    fromEmail = 'senderalex@example.com'
}) {
    const requestData = {
        sender: {
            name: userName,
            email: fromEmail,
        },
        to: [
            {
                email: to,
                name: 'John Doe',
            },
        ],
        subject: 'User message',
        htmlContent: CodeEmail(userName, message, fromEmail),
    };

    try {
        const response = await fetch('https://api.brevo.com/v3/smtp/email', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'api-key': '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',
            },
            body: JSON.stringify(requestData),
        });
        const result = await response.json();

        if (response.ok) {
            console.log('Email sent successfully:', result);
        } else {
            console.error('Failed to send email:', result);
            return  'Email is not valid!'
        }
    } catch (error) {
        return error
    }
}
